import { Box } from '@mui/material';
import DemographicChartContainer from '../components/charts/demographic/DemographicChartContainer';
import ReportDetailsTable from './ReportDetailsTable';
import CompoundCardsList from './CompoundCardsList';
import { CompoundCardsListProps, ResultTabNavigatorExtraProps } from '../types/reports';
import { BubbleViewContent } from './tabsContent/BubbleViewContent';
import TimelineChartContainer from '../components/charts/timeline/TimelineChartContainer';
import { ABOVE_RANGE } from '../constants/report';

type ResultTabContentProps = CompoundCardsListProps &
  ResultTabNavigatorExtraProps & { contentRef: React.RefObject<HTMLDivElement>; reportDate: string };

const ResultTabContent = ({
  contentRef,
  compoundDataList,
  compoundMetaData,
  nasemScore,
  activeView,
  reportDate,
  allResults,
}: ResultTabContentProps) => {
  const hasAboveRange = compoundDataList.some((item) => item.ddfv.label === ABOVE_RANGE);

  const renderContent = () => {
    switch (activeView) {
      case 'comparison':
        return <DemographicChartContainer nasemScore={Number(nasemScore)} hasAboveRange={hasAboveRange} />;
      case 'card':
        return <CompoundCardsList compoundDataList={compoundDataList} compoundMetaData={compoundMetaData} />;
      case 'table':
        return <ReportDetailsTable compoundDataList={compoundDataList} compoundMetaData={compoundMetaData} />;
      case 'bubble':
        return <BubbleViewContent compoundDataList={compoundDataList} reportDate={reportDate} />;
      case 'timeline':
        return <TimelineChartContainer allResults={allResults} compoundMetaData={compoundMetaData} />;
      default:
        return null;
    }
  };

  return (
    <Box sx={{ marginBottom: '16px' }} ref={contentRef}>
      <Box sx={{ marginTop: 2 }}>{renderContent()}</Box>
    </Box>
  );
};

export default ResultTabContent;
